import { Popover } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useState } from "react";
import { RootState } from "../store/store";
import NotificationPanel from "../components/Notification/NotificationPanel";
import { useSelector } from "react-redux";

export default function NotificationBell()
{
  const [open, setOpen] = useState(false);
  const notifications = useSelector((state: RootState) => state.notificationSlice.total) || [];

  const unreadCount = notifications.filter((n) => !n.read).length;

  const handleOpenChange = (newOpen: boolean) =>
  {
    setOpen(newOpen);
  };

  return (
    <Popover
      open={open}
      onOpenChange={handleOpenChange}
      content={<NotificationPanel onClose={() => setOpen(false)} />}
      trigger="click"
      placement="bottomRight"
      overlayClassName="notification-popover"
      getPopupContainer={(triggerNode) => triggerNode.parentElement as HTMLElement}
    // destroyOnClose={true}
    >
      <div className="relative cursor-pointer">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#2b3a55] border border-[#35486F] hover:bg-[#33466a] transition">
          <BellOutlined className="text-white text-lg" />
        </div>
        {unreadCount > 0 && (
          <div className="absolute -top-1 -right-1 w-5 h-5 bg-[#ff5b3d] rounded-full border-2 border-[#0f172a] flex items-center justify-center">
            <span className="text-[10px] text-white font-bold">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          </div>
        )}
      </div>
    </Popover>
  );
}
